<template>
  <div class="seckill-list-item-component">
    <div class="seckill-list-item-time">
      <div class="seckill-list-item-time-name">秒杀时间</div>
      <div class="seckill-list-item-time-value">
        {{ item.seckill.startTime | formatTime('MM.dd 周a HH:ii') }}
      </div>
    </div>
    <router-link class="seckill-list-item-content"
                 :to="getProductPath(item.target.type, item.target.id)"
    >
      <ym-img class="seckill-list-item-cover"
              :src="item.cover"
              :format="format"
              :resize="{ w: 180, h: 135 }"
      />
      <div class="seckill-list-item-content--right">
        <div class="seckill-list-item-title ym-ellipsis">{{ item.title }}</div>
        <div class="seckill-list-item-content--bottom">
          <div class="seckill-list-item-content--bottom-left">
            <ym-price v-if="price"
                      name="原价"
                      :value="price.delete"
                      type="delete"
            />
            <ym-price v-if="price"
                      :name="price.name"
                      :value="price.value"
            />
          </div>
          <ym-button v-if="button"
                     class="seckill-grid-item-button"
                     size="small"
                     :type="button.type"
                     :plain="button.plain"
                     :disabled="button.disabled"
                     v-ym-report:SECKILL_PRODUCT_BTN_CLICK="item"
                     @click.prevent.stop="mixinHandleClickSeckillBtn(button)"
          >
            {{ button.hint }}
          </ym-button>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
  import Button from '@/pages/Seckill/components/SeckillBtn';
  import Price from '@/pages/Seckill/components/SeckillPrice';
  import seckillDoSeckillMixin from '@/mixins/seckill/doSeckill';
  import { getProductPath } from '@/utils';

  export default {
    name: 'SeckillListItem',
    mixins: [seckillDoSeckillMixin],
    components: {
      'ym-button': Button,
      'ym-price': Price,
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    computed: {
      price() {
        return this.item.render.price;
      },
      button() {
        return this.item.render.button;
      },
      format() {
        const { cover } = this.item;
        const res = cover.match(/.(jpg|png|jpeg|webp|bmp|gif|tiff)/)[0].replace('.', '');
        return res === 'jpeg' ? 'jpg' : res;
      },
    },
    methods: {
      getProductPath,
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .seckill-list-item {
    &-component {
      overflow: hidden;
      margin-top: @size-medium;
      padding: @size-medium @size-base;
      border-radius: @seckill-item-border-radius;
      box-shadow: @seckill-item-shadow;
      background: @color-white;
    }

    @list-item-time-height: 50px;
    @list-item-time-radius: @list-item-time-height/2;
    &-time {
      display: inline-flex;
      height: @list-item-time-height;
      padding-right: @size-base;
      margin-bottom: @size-small;
      line-height: @list-item-time-height;
      align-items: center;
      font-size: @font-size-medium;
      font-weight: @font-weight-bold;
      color: @seckill-highlight;
      border-radius: @list-item-time-radius;
      border: 2px solid @seckill-highlight;

      &-name {
        box-sizing: border-box;
        align-self: stretch;
        margin: 0 @size-small 0 0;
        padding: 0 @size-small;
        flex-shrink: 0;
        color: @color-white;
        border-radius: @list-item-time-radius;
        background: @seckill-highlight;
      }
    }

    &-content {
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &--right {
        align-self: stretch;
        overflow: hidden;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      &--bottom {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
      }
    }

    &-cover {
      overflow: hidden;
      width: 180px;
      flex-shrink: 0;
      margin-right: @size-small;
      border-radius: @seckill-item-cover-border-radius;
    }


  }
</style>
